var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        },
      },
    },
    [
      _vm.message
        ? _c(
            "div",
            {
              staticClass: "notification is-light",
              class: _vm.messageType,
              attrs: { "data-test": "error-notification" },
            },
            [_vm._v(" " + _vm._s(_vm.message) + " ")]
          )
        : _vm._e(),
      _c(
        "required-field",
        {
          attrs: {
            error: _vm.$v.email.$error,
            required: _vm.$v.email.required,
            label: "Email",
          },
        },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.$v.email.$model,
                expression: "$v.email.$model",
                modifiers: { trim: true },
              },
            ],
            staticClass: "input",
            class: { "is-danger": _vm.$v.email.$error },
            attrs: { type: "text", "data-test": "email" },
            domProps: { value: _vm.$v.email.$model },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.$v.email, "$model", $event.target.value.trim())
              },
              blur: function ($event) {
                return _vm.$forceUpdate()
              },
            },
          }),
          !_vm.$v.email.email
            ? _c(
                "p",
                {
                  staticClass: "help is-danger",
                  attrs: { "data-test": "email-validation" },
                },
                [_vm._v(" We require a valid email address ")]
              )
            : _vm._e(),
        ]
      ),
      _c(
        "required-field",
        {
          attrs: {
            error: _vm.$v.password.$error,
            required: _vm.$v.password.required,
            label: "Password",
          },
        },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.$v.password.$model,
                expression: "$v.password.$model",
                modifiers: { trim: true },
              },
            ],
            staticClass: "input",
            class: { "is-danger": _vm.$v.password.$error },
            attrs: { type: "password", "data-test": "password" },
            domProps: { value: _vm.$v.password.$model },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.$v.password, "$model", $event.target.value.trim())
              },
              blur: function ($event) {
                return _vm.$forceUpdate()
              },
            },
          }),
          !_vm.$v.password.minLength
            ? _c(
                "p",
                {
                  staticClass: "help is-danger",
                  attrs: { "data-test": "password-validation" },
                },
                [
                  _vm._v(
                    " Password must have at least " +
                      _vm._s(_vm.$v.password.$params.minLength.min) +
                      " "
                  ),
                ]
              )
            : _vm._e(),
        ]
      ),
      _c("div", { staticClass: "buttons mt-5" }, [
        _c(
          "button",
          {
            staticClass: "button is-success is-fullwidth",
            class: { "is-loading": _vm.fetching },
            attrs: { disabled: !_vm.isValid, "data-test": "submit" },
          },
          [_vm._v(" Log in ")]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }